import { CURRENCY_MODEL_KEY } from 'models/daos/currency/constants'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { createSelector } from 'reselect'

function getSelectedCurrencySelector () {
  return createSelector(state => state && state.currencies,
    (currencies) => currencies.selected
  )
}

export const hasCurrenciesSelect = state => {
  return state?.currencies?.all?.data?.length > 1
}

function getCurrencySelector () {
  return createSelector(getSelectedCurrencySelector(),
    state => state && state.currencies,
    (selectedCurrency, currencies) => (
      currencies.data[selectedCurrency] || currencies.data.USD
    )
  )
}

function getNameCurrencySelector () {
  return createSelector(getCurrencySelector(), (currency) => {
    return getValueReduxUtil(currency, CURRENCY_MODEL_KEY.NAME)
  })
}

function getValueCurrencySelector () {
  return createSelector(getCurrencySelector(), (currency) => {
    return getValueReduxUtil(currency, CURRENCY_MODEL_KEY.VALUE)
  })
}

export {
  getSelectedCurrencySelector,
  getNameCurrencySelector,
  getValueCurrencySelector
}
